import React from 'react';
import { DisplayTimes } from '../..';
import { SpecialistCard } from '../../../../components/SpecialistCard';
import { ScheduleItemProps } from '../../../../models/Schedule';
import { ScheduleSpecialist } from '../../../../models/ScheduleSpecialist';
import { handleProductName } from '../../../../utils';
import { handleSpecialtiesWithExpertises } from '../../../../utils/specialist-utils';
import * as S from '../../styles';

type ProfessionalCardProps = {
  schedule?: ScheduleItemProps;
  selectedTime?: DisplayTimes;
  isProductWithProfessional: boolean;
  scheduleSpecialist: ScheduleSpecialist;
};

export const ProfessionalCard = ({
  schedule,
  selectedTime,
  isProductWithProfessional,
  scheduleSpecialist
}: ProfessionalCardProps) => {
  return (
    <>
      {scheduleSpecialist.resource && (
        <S.SpecialistCardWrapper>
          <SpecialistCard
            imgSrc={scheduleSpecialist.image || ''}
            title={scheduleSpecialist.resource.name}
            description={handleSpecialtiesWithExpertises(scheduleSpecialist?.specialityList)}
          />
        </S.SpecialistCardWrapper>
      )}
      {schedule?.useResouce && schedule?.resource ? (
        <S.SpecialistCardWrapper>
          <SpecialistCard
            imgSrc={`https://aps-digital.s3.amazonaws.com/profissionais/${schedule.resource.crm}.jpg`}
            title={schedule.resource.name}
            description={schedule.resource.role}
          />
        </S.SpecialistCardWrapper>
      ) : (
        <>
          {isProductWithProfessional && selectedTime?.slots.length ? (
            <S.SpecialistCardWrapper>
              <SpecialistCard
                imgSrc={`https://aps-digital.s3.amazonaws.com/profissionais/${selectedTime?.slots[0].resourceId}.jpg`}
                title={selectedTime?.slots[0].resource || handleProductName(schedule?.productName || '') || ''}
                description={
                  selectedTime?.slots[0].resource ? handleProductName(schedule?.productName || '') || '' : 'À definir'
                }
              />
            </S.SpecialistCardWrapper>
          ) : null}
        </>
      )}
    </>
  );
};
